import { l as e, n as t, t as n } from "./gallery-preview-carousel-DivlId6s.js";
import { createCommentVNode as r, createElementBlock as i, createElementVNode as a, createVNode as o, defineComponent as s, onBeforeMount as c, openBlock as l, ref as u, toDisplayString as d, unref as f } from "vue";
import { QBtn as p } from "quasar";
//#region src/components/gallery-related-gallery.vue?vue&type=script&setup=true&lang.ts
var m = {
	key: 0,
	class: "related-gallery-wrapper"
}, h = { class: "related-gallery-info" }, g = { class: "related-gallery-kicker" }, _ = { class: "related-gallery-title" }, v = /* @__PURE__ */ t(/* @__PURE__ */ s({
	__name: "gallery-related-gallery",
	props: { relatedGalleryUuid: { default: "" } },
	emits: ["click:remove-gallery"],
	setup(t, { emit: s }) {
		let v = s, y = u(), b = t;
		return c(async () => {
			if (b.relatedGalleryUuid) try {
				y.value = await e(b.relatedGalleryUuid);
			} catch (e) {
				console.error(e);
			}
		}), (e, t) => y.value ? (l(), i("div", m, [
			o(n, {
				references: y.value.references,
				"preview-size": {
					width: 60,
					height: 60
				},
				class: "related-gallery-carousel"
			}, null, 8, ["references"]),
			a("div", h, [a("span", g, d(y.value.kicker), 1), a("span", _, d(y.value.title), 1)]),
			o(f(p), {
				icon: "close",
				flat: "",
				dense: "",
				class: "related-gallery-remove-button",
				onClick: t[0] ||= (e) => v("click:remove-gallery", y.value._id)
			})
		])) : r("", !0);
	}
}), [["__scopeId", "data-v-9f07b35d"]]);
//#endregion
export { v as t };

//# sourceMappingURL=gallery-related-gallery-sc1cLKUC.js.map